import api from "../services/api";

function getApiOrigin() {
  const baseUrl = String(api?.defaults?.baseURL || "").trim();
  if (!baseUrl) return "";
  return baseUrl.replace(/\/api\/?$/, "");
}

export function resolveAssetUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw) || raw.startsWith("blob:") || raw.startsWith("data:")) return raw;

  const apiOrigin = getApiOrigin();
  if (!apiOrigin) {
    if (raw.startsWith("/")) return raw;
    if (raw.includes("/")) return `/${raw.replace(/^\/+/, "")}`;
    return raw;
  }

  if (raw.startsWith("/")) return `${apiOrigin}${raw}`;
  if (raw.includes("/")) return `${apiOrigin}/${raw.replace(/^\/+/, "")}`;
  return raw;
}

export function isSecureFileUrl(value) {
  const raw = String(value || "").trim();
  return (
    /^\/api\/files\/[^/]+\/(view|download)$/i.test(raw) ||
    /^https?:\/\/[^/]+\/api\/files\/[^/]+\/(view|download)$/i.test(raw)
  );
}

export async function fetchDocumentBlob(url) {
  const value = String(url || "").trim();
  if (!value) throw new Error("Bestands-URL ontbreekt");

  if (isSecureFileUrl(value)) {
    const requestUrl = resolveAssetUrl(value);
    const res = await api.get(requestUrl, { responseType: "blob" });
    return res.data;
  }

  const res = await fetch(resolveAssetUrl(value));
  if (!res.ok) throw new Error("Bestand ophalen mislukt");
  return res.blob();
}

export async function createObjectUrlFromDocument(url) {
  const blob = await fetchDocumentBlob(url);
  return window.URL.createObjectURL(blob);
}
